<template>
    <div>
        <nav class="sidebar">
            <header
                    class="logo"
                    style="text-align:left;font-size:22px;margin:15px 10px;"
            >
                <a title="Back" @click="$router.go(-1)"
                ><span class="text-warning"
                ><span
                        class="glyphicon glyphicon-chevron-left"
                        style="top:-1px;"
                ></span>
            History</span
                ></a
                >
            </header>

            <p></p>
            <h5 class="navTitle" >Search</h5>
            <input type="text">
            <p></p>
        </nav>
        <div class="wrap-wide">
            <input
                    type="text"
                    style="width:98%;border-radius:15px;border:0px solid gray;padding:6px;margin:6px"
                    disabled
                    :value="pageUrl"
            />

            <div v-if="progress">
                Progress: {{progress}}
            </div>

        <div id="chart" style="border:1px solid red" v-if="selectBoxes.length > 0">
            <apexchart ref="chart" type="heatmap" height="150" :options="chartOptions" :series="chartSeries"></apexchart>
        </div>
            <b-input-group prepend="Item">
                <b-input-group-prepend is-text>
                    <button @click="next(-1)">Prev</button>
                </b-input-group-prepend>
                <b-input-group-prepend is-text> <button @click="play()">Play</button></b-input-group-prepend>
                <b-input-group-prepend is-text>   <button @click="next(1)">Next</button></b-input-group-prepend>
                <b-input-group-prepend is-text> <button @click="setSelection('body')">Clear</button></b-input-group-prepend>

            </b-input-group>





        <Widget  class="" style="position:relative;padding:0;margin:0">

                <div v-for="box in selectBoxes" @click="selectBox(box)" class="hover-show" :style="`position:absolute;border:1px solid red;left:${box.x}px;top:${box.y}px;width:${box.width}px;height:${box.height}px;z-index:${box.zIndex}`"></div>

            <div id="canvas"></div>
        </Widget>
        </div>

    </div>
</template>

<script>
  import axios from "axios";
  import * as PIXI from 'pixi.js'
  import gql from "graphql-tag";
  import Widget from '@/components/Widget/Widget';
  import { mapState } from 'vuex';
  import { select } from 'optimal-select'
  import pixelmatch from "pixelmatch"

  export default {
    name: 'Subscriptions',
    components: { Widget, },
    apollo: {
      website:{
        query(){ return gql`query{
            website:websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
                id
                url
                websites_crawls(order_by: {id: desc}, limit: 30){
                  websites_crawledpages(where: {url: {_eq: "${this.pageUrl}"}}){
                    url
                    id
                    websites_devicerenders(where: {websites_device:{ id: {_eq: "chrome"}}}){
                      render_data
                      content
                      websites_device{
                        name
                      }
                      boxes
                      screenshots
                    }
                  }
                }
            }
        }`
        },
        skip () {
          return !(this.isMounted && this.activeSite.id && this.pageUrl && this.app) ;
        },
        result(data){
          this.data = data.data.website[0];
          this.crawls = [];
          for (let i=0; i < this.data.websites_crawls.length; i++){
            if (this.data.websites_crawls[i].websites_crawledpages.length > 0){
              this.crawls.push(this.data.websites_crawls[i])
            }
          }
       //   this.crawls.reverse();
          window.data = data;
          this.loadResources();
        }
      },
    },
    data(){
      return {
        completed: false,
        isMounted: false,
        chart:{
          series: [
            {
              name: "Changes",
              data: [ ]
            },
            {
              name: "Series 2",
              data: []
            }
          ],
          options: {
            annotations: {
              xaxis: [
                {
                  x: '2:00',
                  borderColor: '#00E396',
                  strokeDashArray: 0,
                  label: {
                    borderColor: '#00E396',
                    style: {
                      fontSize: '12px',
                      color: '#fff',
                      background: '#00E396'
                    },
                    orientation: 'horizontal',
                    offsetY: -7,
                    text: 'Annotation Test'
                  }
                }
              ]
            },
            chart: {
              toolbar: {
                show: false
              },
              height: 450,
              type: 'heatmap',
            },
            dataLabels: {
              enabled: false
            },
            colors: ["#008FFB"],
            xaxis: {
              type: 'category',
            },
            title: {
              text: 'Page Changes'
            },
            grid: {
              padding: {
                right: 20
              }
            }
          },
        },
        render: {},
        renderIndex: 0,
        // pageUrl: 'https://www.producthunt.com/',
        pageUrl: 'https://www.amazon.com/dp/B07D58KJ28',
        app: {},
        sprites:[],
        ratio: 1,
        crawls: [],
        mainTexture: null,
        progress: 1,
        moves: [],
        // selector: ".main_51873 > div:nth-child(1) > div:nth-child(1) > .container_88f8e.large_bbe28:nth-child(2)",
        selector: "html",
        // selector: '[data-test="post-item-242559"] .link_523b9 .content_31491 .font_9d927.medium_51d18.semiBold_e201b.title_9ddaf.lineHeight_042f1.underline_57d3c.pagewatch-injected',
        // selector: '[data-test="post-item-242658"] .voteButtonWrap_4c515 [data-test="vote-button"]',
        // selector: ".card_6ca6e.hover_c90b6.item_00e2a.showBottomBorder_28c32",
        // selector: ".card_6ca6e.hover_c90b6.item_00e2a.showBottomBorder_28c32",
        // selector: ".main_51873 > div:nth-child(1) > div:nth-child(1) > div:nth-child(1) .container_88f8e.large_bbe28",
        selectorBox: {},
        selectorBoxIndex: 0,
        selectBoxes: [],
      }
    },
    methods: {
      next(dir){
        this.renderIndex += dir;
        this.fadeToIndex(this.renderIndex)
      },
      setSelection(selector){
        this.selector = selector;
        // this.loadBoxes();
        // this.loadSelectionBoxes();
        this.fadeToIndex(this.renderIndex, 1)

      },
      selectBox(box){
        this.setSelection(box.selector)
      },
      firstCustomParent(el, containers, boxes, selectorBoxIndex){
        let p = el.parentElement;
        for (let i=0;i<30; i++){
          if (!p){
            break;
          }
          let parentId = p.getAttribute('data-pagewatch-box')
          if (parentId == selectorBoxIndex){
            return {
              container: null,
              y: boxes[selectorBoxIndex].y,
              x: boxes[selectorBoxIndex].x
            }
          }
          if (!parentId){
            break;
          }
          if (containers[parentId]){
            return {
              container: containers[parentId],
              y: boxes[parentId].y,
              x: boxes[parentId].x
            }
          }
          p = p.parentElement;
        }
        return false
      },
      play(){
        let count = 0;
        console.log('play')
        this.loadBoxes();
        console.log('done')
        // return;
        console.log('loadboxes')
        this.calc();
        console.log('calc')
        if (this.moves.length === 0){
          count = 50;
        }
        let interval = setInterval( () =>{
          count += 1;
          for (let move of this.moves){
            move.el.y += move.y*0.02
            move.el.x += move.x*0.02
          }
          if (count >= 50){
            clearInterval(interval);
            this.fadeToIndex(this.renderIndex+1).then( ()=>{
              this.loadBoxes();
              if (this.renderIndex < this.crawls.length-1){
                this.play()
              }
            })
          }
        }, 20);
      },
      subSpriteFromTexture(x, y, width, height, texture){
        // let r = new PIXI.Rectangle(x, y, width, Math.min(2300-y, height));
        let r = new PIXI.Rectangle(Math.floor(x), Math.floor(y), Math.floor(width), Math.floor(height));

        // this.solidRect(b.x * this.ratio, b.y * this.ratio, b.width * this.ratio, b.height * this.ratio, 0x00CCFF + i * 34)

        let sprite = new PIXI.Texture(texture);
        sprite.frame = r;
        return new PIXI.Sprite(sprite);
      },
      solidRect(x, y, width, height, color){
        color = 0xF3F3F3;
        let solidBackground = new PIXI.Graphics();
        solidBackground.beginFill(color);
        solidBackground.drawRect(x, y, width, height);
        solidBackground.endFill();
        return solidBackground;
      },
      calc(){
        this.render = this.crawls[this.renderIndex].websites_crawledpages[0].websites_devicerenders[0];
        let parser = new DOMParser();
        let render2 = this.crawls[this.renderIndex+1].websites_crawledpages[0].websites_devicerenders[0];
        let boxes2 = render2.boxes;
        let doc = parser.parseFromString(render2.content, "text/html");

        let containers = {};
        let containers2 = {};
        this.moves = [];
        window.containers = containers;
        let selectorBoxIndex2 = this.getSelectorBoxIndex(render2.content, this.selector)


        for (let i=0; i < this.sprites.length; i++){
          if (!this.sprites[i]){
            continue;
          }
          let entry = this.sprites[i];
          let matchedElements = null
          try {
            matchedElements = doc.querySelectorAll(this.sprites[i].selector);
          }
          catch(e){
            continue
          }
          if (matchedElements.length !== 1){
            continue;
          }
          let el = matchedElements[0];


          if (el) {
            let index2 = (el.getAttribute('data-pagewatch-box'));

            let parentY = this.firstCustomParent(entry.el, containers, this.render.boxes, this.selectorBoxIndex)
            let parentY2 = this.firstCustomParent(el, containers2, boxes2, selectorBoxIndex2)

            if (!(parentY && parentY2 && boxes2[index2])){
              continue
            }


              let relPos1 = (parentY.y - this.render.boxes[entry.index].y) * this.ratio
              let relPos2 = (parentY2.y - boxes2[index2].y) * this.ratio

            let relPos1X = (parentY.x - this.render.boxes[entry.index].x) * this.ratio
            let relPos2X = (parentY2.x - boxes2[index2].x) * this.ratio

              if (Math.abs(relPos1 - relPos2) > 1 && Math.abs(relPos1 - relPos2) <  800){
               let b = this.render.boxes[entry.index];

               let container = null;
               if (parentY.container){
                 container = parentY.container;

                 let height = Math.min(b.height, this.mainTexture.orig.height/this.ratio - b.y);
                 let width = Math.min(b.width, this.mainTexture.orig.width/this.ratio - b.x);

                 let sprite2 = this.subSpriteFromTexture(b.x * this.ratio, b.y * this.ratio, width * this.ratio, height * this.ratio, this.mainTexture);
                 sprite2.y =  b.y * this.ratio - container.y;
                 sprite2.x =  b.x * this.ratio- container.x;

                 let solidBackground = this.solidRect(b.x * this.ratio - container.x, b.y * this.ratio - container.y, b.width * this.ratio, b.height * this.ratio, 0x00CCFF +i*34)
                 container.addChildAt(solidBackground, 1);
                 container.addChild(sprite2);
                 this.moves.push({el: sprite2, y: relPos1 - relPos2,  x: (relPos1X - relPos2X)  })
               }
               else{
                   container = new PIXI.Container();
                   window.el  =el

                   container.x = (b.x-this.selectorBox.x)* this.ratio;
                   container.y = (b.y-this.selectorBox.y) * this.ratio;

                   let solidBackground = this.solidRect((b.x-this.selectorBox.x)* this.ratio, (b.y-this.selectorBox.y) * this.ratio, b.width * this.ratio, b.height * this.ratio, 0x00CCFF + i * 34)
                   // let solidBackground = this.solidRect(b.x * this.ratio, b.y * this.ratio, b.width * this.ratio, b.height * this.ratio, 0x00CCFF + i * 34)
                   // let subSprite = this.solidRect(b.x * this.ratio, b.y * this.ratio, b.width * this.ratio, b.height * this.ratio,  0x0000AA )

                   let height = Math.min(b.height, this.mainTexture.orig.height/this.ratio - b.y);
                   let width = Math.min(b.width, this.mainTexture.orig.width/this.ratio - b.x);
                   let subSprite = this.subSpriteFromTexture(b.x * this.ratio, b.y * this.ratio, width * this.ratio, height * this.ratio, this.mainTexture)
                   container.addChild(subSprite);

                   if (container.y > 0) {
                       this.moves.push({el: container, y:(relPos1 - relPos2), x: (relPos1X - relPos2X) });
                   }

                   this.app.stage.addChildAt(solidBackground, 1);
                   this.app.stage.addChild(container);
               }

              containers[entry.index] = container;
              containers2[index2] = el;
              }
          }
        }
      },
      loadResources(){
        console.log('ITEMS:"', this.crawls.length)
        for (let i=0; i < this.crawls.length; i++){
          let render = this.crawls[i].websites_crawledpages[0].websites_devicerenders[0];
          let screenshot = render.screenshots.full.screenshot.url;
          this.app.loader.add(screenshot)
        }
        this.app.loader.onProgress.add( (p)=>{
          this.progress += 1;
        });

        this.chart.options.xaxis.categories = [];
        this.chart.series[0].data = [];

        this.app.loader.load(
          (loader, resources) => {
            this.chart.options.xaxis.categories.push(`First`);
            this.chart.series[0].data.push({
              x: 'Changes',
              y: 0
            })
            for (let i=0; i < this.crawls.length-1; i++) {
              this.chart.options.xaxis.categories.push(`${i}:00`);
            }
            console.time('loadSelectionBoxes')
            this.loadSelectionBoxes();
            console.timeEnd('loadSelectionBoxes')
            console.time('loadBoxes')
            this.loadBoxes();
            console.timeEnd('loadBoxes')
            this.fadeToIndex(this.renderIndex)
          }
        );

      },
      loadSelectionBoxes(){
     //   return;
        let imageUrls = [];
        this.chart.series[0].data = [];
        for (let i=0; i < this.crawls.length; i++) {
          this.chart.series[0].data.push({
            x: 'Changes',
            y: 0
          });
          let render1 = this.crawls[i].websites_crawledpages[0].websites_devicerenders[0];
          let screenshot1 = render1.screenshots.full.screenshot.url;
          imageUrls.push(screenshot1)
        }

        var worker = new Worker( '@/pages/Seo/worker.js', { type: 'module' });
        worker.addEventListener('message', (e) => {
          this.chart.series[0].data[e.data.i+1] = ({
            x: 'Changes',
            y: e.data.diff
          });
          this.$refs.chart.updateSeries([{
            data: this.chart.series[0].data
          }], false, true);
        }, false);

        worker.postMessage(imageUrls);
      },

      // Returns the box index ('data-pagewatch-box') for the given content and CSS selector
      getSelectorBoxIndex(content, selector){
        try {
          let parser = new DOMParser();
          let doc = parser.parseFromString(content, "text/html");

          let matchedElements = doc.querySelectorAll(selector);
          if (matchedElements.length !== 1) {
            console.log('nope')
            return false;
          }
          let el = matchedElements[0];
          return el.getAttribute('data-pagewatch-box') || 0;
        }
        catch(e){
          return 0
        }
      },
      fadeToIndex(index, steps=50){
        let promise = new Promise(
          (resolve, reject) => {
            this.renderIndex = index;
            this.render = this.crawls[index].websites_crawledpages[0].websites_devicerenders[0];
            let screenshot = this.render.screenshots.full.screenshot.url;
            // console.log(screenshot)
            // console.log(this.render)
            this.ratio = this.render.screenshots.full.screenshot.height / this.render.screenshots.full.height;

            let selectorBoxIndex = this.getSelectorBoxIndex(this.render.content, this.selector);
            this.selectorBoxIndex = selectorBoxIndex;
            // console.log(selectorBoxIndex)
            console.log(this.render.boxes[selectorBoxIndex])

            this.mainTexture = this.app.loader.resources[screenshot].texture;
            let width =  this.render.boxes[selectorBoxIndex].width*this.ratio;
            let height = this.render.boxes[selectorBoxIndex].height*this.ratio;

            height = Math.min(height, (this.mainTexture.orig.height/this.ratio - this.render.boxes[selectorBoxIndex].y ) * this.ratio);
            width = Math.min(width, (this.mainTexture.orig.width/this.ratio - this.render.boxes[selectorBoxIndex].x) * this.ratio);

            let fullImage = this.subSpriteFromTexture(this.render.boxes[selectorBoxIndex].x*this.ratio, this.render.boxes[selectorBoxIndex].y*this.ratio, width, height, this.mainTexture);
            this.selectorBox = this.render.boxes[selectorBoxIndex]
            window.selectorBox = this.selectorBox;
            // if(window.fullImage){
            //   let m = pixelmatch( this.app.renderer.extract.pixels(window.fullImage), this.app.renderer.extract.pixels(fullImage), null, width, height, {threshold: 0.1});
            //   console.log('matching', m)
            // }

            // let fullImage = this.subSpriteFromTexture(this.render.boxes[selectorBoxIndex].x*this.ratio, this.render.boxes[selectorBoxIndex].y*this.ratio, this.render.screenshots.full.screenshot.width-this.render.boxes[selectorBoxIndex].x*this.ratio, Math.min(20000, this.render.screenshots.full.screenshot.height), this.mainTexture);
            fullImage.alpha = 0;
            this.app.stage.addChild(fullImage);
            window.fullImage = fullImage;

            let interval = setInterval( () =>{
              fullImage.alpha += 1/steps

              if (fullImage.alpha >= 1){
                clearInterval(interval)
                for (let i=this.app.stage.children.length-1; i >= 0; i--){
                  if (this.app.stage.children[i] !== fullImage) {
                    this.app.stage.removeChild(this.app.stage.children[i]);
                  }
                }
                // this.loadBoxes();
                if (index > 0) {
                  this.$refs.chart.clearAnnotations()
                  this.$refs.chart.addXaxisAnnotation(
                  {
                    x: `${index-1}:00`,
                    borderColor: '#00E396',
                    strokeDashArray: 0,
                    label: {
                      borderColor: '#00E396',
                      style: {
                        fontSize: '12px',
                        color: '#fff',
                        background: '#00E396'
                      },
                      orientation: 'horizontal',
                      offsetY: -7,
                      text: `${index}:00`,
                    }
                  })
                }
                resolve()
              }
            }, 10);
          }
        );

        return promise;

      },
      loadBoxes(){

        if (!this.app.loader){
          return
        }
       // return;
        let parser = new DOMParser();
        this.sprites = [];
        window.sprites = this.sprites;

        this.selectBoxes = [];
        window.selectBoxes = this.selectBoxes;

        this.render = this.crawls[this.renderIndex].websites_crawledpages[0].websites_devicerenders[0];
        let doc = parser.parseFromString(this.render.content, "text/html");
        window.doc = doc;
        window.render = this.render;
        this.ratio = this.render.screenshots.full.screenshot.height / this.render.screenshots.full.height;

        let box = {};
        let boxes = this.render.boxes;
        window.boxes = boxes;

        // this.mainTexture = this.app.loader.resources[screenshot].texture;
        // let fullImage = this.subSpriteFromTexture(0, 0, 680, 800, this.mainTexture);
        // fullImage.alpha = alpha;

        // this.app.stage.addChild(fullImage);


        for (let index=0; index < boxes.length; index++){
          box = boxes[index];
          if (box.y > 18000){
            continue
          }

          if (box.width > 5 && box.height > 5  &&  box.y < 18500 && box.height < 10000 && box.width < 5000) {
              let el = doc.querySelector(`[data-pagewatch-box="${index}"]`)
             let selector = '';
              try {
                selector = select(el, {
                  root: doc, ignore: {
                    attribute(name, value, defaultPredicate) {
                      return name.startsWith('data-pagewatch') || name.startsWith('tabindex')
                    }
                  }
                });
              }
              catch(e){}
              this.sprites.push({
                sprite: null,
                index: index,
                el: el,
                box: box,
                selector: selector
              });

              if (box.y < 18500) {
                this.selectBoxes.push({
                  x: box.x * this.ratio,
                  y: box.y * this.ratio,
                  width: box.width * this.ratio,
                  height: Math.min(18800, box.height * this.ratio),
                  selector: selector,
                  zIndex: this.selectBoxes.length,
                })
              }
          }
        }

      },

    },
    computed: {
      ...mapState({activeSite: 'activeSite'}),
      chartSeries: function(){
        return this.chart.series;
      },
      chartOptions: function(){
        return this.chart.options;
      }
    },
    mounted() {
      window.p = PIXI;
      let app = new PIXI.Application({width:1900, height: 15500});
      this.app = app;
      document.getElementById('canvas').appendChild(this.app.view)
      this.isMounted = true;
      window.app = app;

      window.pixelmatch = pixelmatch;

    },
  };
</script>

<style src="./Crawl.scss" lang="scss" />


<style lang="scss">

</style>
